export const titleStatusOptions = [
    { value: "Stationary", label: "Stationary" },
    { value: "Run & Drive", label: "Run & Drive" },
    { value: "Starts", label: "Starts" },
    { value: "Can't test", label: "Can't test" },
    { value: "Unknown", label: "Unknown" }, 
  ];